<div class="login-dialog">
  <h4 class="login-suporte-title" id="login-suporte-title">Login Suporte</h4>
  <form
    class="login-suporte-form login-dialog__body"
    autocomplete="off"
    (input)="validationMessage = ''"
    (keydown.enter)="confirmFromEnter($event)"
  >
    <div class="mb-4">
      <label
        for="support-login-name"
        class="form-label fw-semibold mb-2 text-subtitle"
      >
        <i class="bi bi-person me-2 text-icon-secondary" aria-hidden="true"></i>
        Nome do usuário
      </label>
      <input
        type="text"
        class="form-control rounded-4"
        id="support-login-name"
        placeholder="Digite seu nome de usuário"
        aria-label="Nome do usuário"
        [formControl]="nome"
      />
    </div>
    <div class="mb-4">
      <label
        for="support-login-password"
        class="form-label fw-semibold mb-2 text-subtitle"
      >
        <i class="bi bi-lock me-2 text-icon-secondary" aria-hidden="true"></i>
        Senha
      </label>
      <input
        type="password"
        class="form-control rounded-4"
        id="support-login-password"
        placeholder="Digite sua senha"
        aria-label="Senha"
        [formControl]="senha"
      />
    </div>
  </form>

  @if (validationMessage) {
    <p class="login-dialog__message" role="alert">{{ validationMessage }}</p>
  }

  <div class="login-dialog__actions">
    <button type="button" class="btn btn-secondary" (click)="cancel()">
      Cancelar
    </button>
    <button type="button" class="btn" (click)="confirm()" [disabled]="pending">
      Entrar
    </button>
  </div>
</div>
